import jwtInterceptor from './jwtInterceptor'

export default {
  getRegattas(params) {
    return jwtInterceptor.get('/regattas', { params })
  },
  getRegatta(regattaId) {
    return jwtInterceptor.get(`/regattas/${regattaId}`)
  },
  getEvents(regattaId) {
    return jwtInterceptor.get(`/regattas/${regattaId}/events`)
  },
  getRaces(regattaId, params = {}) {
    return jwtInterceptor.get(`/regattas/${regattaId}/races`, { params })
  },
  getResults(regattaId) {
    return jwtInterceptor.get(`/regattas/${regattaId}/participants/results`)
  },
  getCacheList() {
    return jwtInterceptor.get('/cache/results')
  },
  seedCache() {
    return jwtInterceptor.post('/cache/seed')
  }
}
